module.exports = __webpack_public_path__ + "static/media/img_paihang.bab89ddf.png";